<template>
  <el-col :span="span" :offset="offset" class="esp_search">
    <div class="esp_search_item" :style="{marginBottom: gap}">
      <div class="esp_search_label" :style="{width: labelWidth}">
        {{ labelName }}
      </div>
      <div class="esp_search_input" :style="{width: inputWidth}">
        <slot></slot>
      </div>
    </div>
  </el-col>
</template>

<script>
  export default {
    name: 'EspSearchItem',
    props: {
      span: {             // 栅格布局
        type: Number,
        default: 6
      },
      offset: {           // 分栏偏移栏数
        type: Number,
        default: 0
      },
      gap: {              // 边距
        type: String,
        default: '10px'
      },
      labelWidth: {       // label宽度
        type: String,
        default: '100px'
      },
      inputWidth: {       // 输入框宽度
        type: String,
        default: 'auto'
      },
      labelName: {        // label名称
        type: String,
        default: ''
      }
    }
  }
</script>

<style scoped lang="less">
  .esp_search {
    .esp_search_item {
      display: flex;
      align-items: center;
    }

    .esp_search_label {
      color: #666666;
      font-size: 14px;
      line-height: 100%;
      text-align: right;
      font-weight: normal;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/EspSearchItem.vue